import React from 'react';
import ChangePositionView from "./ChangePositionView.jsx";

const DrawPosition = function(props)
{
   const staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap?" +
   "key=AIzaSyBVa_IqWirflbPclyzJZ31NDM9D2mpju90"+
   "&center=" + props.value.lat + "," + props.value.lng +
   "&zoom=18&size=400x300" + "&markers=|" + props.value.lat + "," + props.value.lng +
   "&maptype=satellite";

   var registerEditedPos = function(newPos)
   {
      if(newPos != null)
         props.onChange(newPos);
      
      props.popModal();
   }

   var viewEditPos = function()
   {
      const modalProps = {
         startPos:{lat: props.value.lat, lng: props.value.lng},
         changePositionCallback:registerEditedPos,
      };

      props.pushModal({modalClass:ChangePositionView, modalProps:modalProps});
   }

   return(
      <div>
         <img src={staticMapUrl}/>
         <button onClick={viewEditPos}>Edit</button>
      </div>
   );
}
export default DrawPosition;


// WEBPACK FOOTER //
// ./js/DrawPosition.jsx